import { gql } from '@apollo/client';

export const GET_PROJECTS = gql`
  query Projects ($companyId: ID!, $limit: Int, $offset: Int, $order: String, $name: String) {
    projects(companyId: $companyId, limit: $limit, offset: $offset, order: $order, name: $name) {
      id
      name
    }
  }
`;
